module.exports = __webpack_public_path__ + "img/reminders.718ce366.png";